import { useMemo } from 'react'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'

import FilterSelect from '@/components/ui/FilterSelect'
import Input from '@/components/ui/Input'

import {
  AddGoodieButton,
  GoodieTable,
  helpers,
  useGoodieTable
} from '@/features/goodies'

function Goodies() {
  const { t } = useLingui()
  const typeOptions = helpers.useGoodieTypeOptions()

  const possibleTypes = useMemo(
    () => typeOptions.map(({ value }) => value),
    [typeOptions]
  )

  const {
    queryVariables,
    selectedGoodies,
    types,
    search,
    setSearch,
    setTypes,
    onSelectGoodie,
    updateSort
  } = useGoodieTable(possibleTypes)

  return (
    <main className="flex flex-col pr-5 pb-6 max-h-full">
      <div className="flex w-full flex-col md:flex-row gap-2.5 pt-1 pb-6 items-start md:items-center">
        <div className="flex flex-row gap-2.5 items-center">
          <AddGoodieButton />
          <FilterSelect
            options={typeOptions}
            selectedValues={types}
            onChange={setTypes}
            placeholder={t`All types`}
          />
        </div>
        <Input
          Icon={SearchList01Icon}
          placeholder={t`Search…`}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <div className="relative w-full rounded bg-white p-5 flex-1 overflow-hidden flex flex-col">
        <div className="size-full overflow-y-auto inset-0">
          <GoodieTable
            variables={queryVariables}
            selectedIds={selectedGoodies}
            onSelect={onSelectGoodie}
            onChangeSort={updateSort}
            hideCheckbox
          />
        </div>
      </div>
    </main>
  )
}

export default Goodies
